import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { OperationsGuard } from "../guards/operations.guard";
import { OrgTypeGuard } from "../guards/org-type.guard";

export const MaqraaAdminRoutes: Route[] = [
  {
    path: "maqraa/dashboard",
    loadComponent: () =>
      import("../../Feature/maqraa-admin/pages/dashboard/maqraa-dashboard.component").then(
        (mod) => mod.MaqraaDashboardComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard, OrgTypeGuard("maqraa")],
  },
  {
    // Reuses the shared students-list component verbatim. Backend scoping
    // happens via the X-Org-Id header the TenantHeaderInterceptor injects,
    // so Maqra'a admins only see their own students on this URL.
    path: "maqraa/students",
    loadComponent: () =>
      import("../../Feature/students/pages/students-list/students-list.component").then(
        (mod) => mod.StudentsListComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard, OrgTypeGuard("maqraa")],
  },
  {
    path: "maqraa/sessions",
    loadComponent: () =>
      import("../../Feature/appointments/pages/appointments-list/appointments-list.component").then(
        (mod) => mod.AppointmentsListComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard, OrgTypeGuard("maqraa")],
  },
  {
    // Both institute and maqraa orgs create maqraahs (public sessions),
    // so no OrgTypeGuard here — backend tenant scoping handles isolation.
    path: "maqraah/create",
    loadComponent: () =>
      import("../../Feature/maqraa-admin/pages/create-maqraah/create-maqraah.component").then(
        (mod) => mod.CreateMaqraahComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
  // H1 (2026-05-06) — list of all maqraahs in the active tenant with
  // edit + soft-delete actions; pairs with create-maqraah.
  {
    path: "maqraah",
    loadComponent: () =>
      import("../../Feature/maqraa-admin/pages/manage-maqraahs/manage-maqraahs.component").then(
        (mod) => mod.ManageMaqraahsComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
  {
    path: "maqraah/edit/:id",
    loadComponent: () =>
      import("../../Feature/maqraa-admin/pages/edit-maqraah/edit-maqraah.component").then(
        (mod) => mod.EditMaqraahComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
];
